import { CleanDatePipe } from './../../../../../pipes/clean-date.pipe';
import { SchoolEnrollmentDetails } from './../../../model/school-enrollment-details.model';
import { SchoolEnrollment } from './../../../model/school-enrollment.model';
import { SchoolEnrollmentComments } from './../../../model/school-enrollment-comments.model';
import { Student } from 'src/app/model/student/student.model';
import { StudentEligibilitiesService } from 'src/app/component/children/service/student-eligibilities.service';
import { PartyRelationshipsService } from './../../../../party/service/party-relationships.service';
import { StudentSchoolEnrollmentService } from './../../../service/student-school-enrollment.service';
import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PartyRelationshipTypes } from 'src/app/component/party/model/party-relationship-types.model';
import { SchoolEnrollmentDetailTypes } from '../../../model/school-enrollment-detail-types.model';
import { EditChildModalComponent } from '../../edit-child-modal-btn/edit-child-modal/edit-child-modal.component';
import Swal from 'sweetalert2';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { School, Grade } from 'src/app/model/school.model';
import { Region } from 'src/app/model/region.model';
import { Organization } from 'src/app/component/common-components/organizations/model/organization.model';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { firstValueFrom, Subject, Subscription } from 'rxjs';

@Component({
    selector: 'edit-child-enrollment-modal',
    templateUrl: './edit-child-enrollment-modal.component.html',
    styleUrls: ['./edit-child-enrollment-modal.component.scss']
})
export class EditChildEnrollmentModalComponent implements OnInit {
    @Input() students!: Student[];
    @Input() schoolEnrollment: SchoolEnrollment;
    @Input() mode: 'view' | '';

    title: string;

    @ViewChild('enrollmentForm') childInfoForm: FormGroupDirective;
    form: UntypedFormGroup;

    // Reference Data
    schoolEnrollmentDetailTypes: SchoolEnrollmentDetailTypes[];
    partyRelationshipStatusTypes: PartyRelationshipTypes;
    missingEoEStudents: Student[];

    selectedSchoolYear: string = ''; // to hold actual school year value
    selectSchoolYear: string = ''; // for initial edit
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenRegion: Region;
    chosenCounty: County;
    chosenSchoolDistrict: SchoolDistrict;
    chosenSchool: School;
    chosenGrades: Grade[] = [];
    selectedIntendToGraduateFrom: Organization;
    residenceDistrict: Organization;
    intendToGraduateFromRequired: boolean = false;
    intendToGraduateFromDisabled: boolean = true;

    // School Enrollment Data
    schoolEnrollmentDetails: SchoolEnrollmentDetails[] = [];
    sed: any = {};
    schoolEnrollmentComments: SchoolEnrollmentComments;

    // Date options
    maxEndOfEligibilityStudent: Student;
    maxTerminationStudent: Student;
    enrollmentDateOptions = {
        minDate: new Date(),
        maxDate: new Date(),
        startAt: new Date()
    };
    withdrawalDateOptions = {
        minDate: new Date(),
        maxDate: new Date(),
        startAt: new Date()
    };
    departureDateOptions = {
        minDate: new Date(),
        maxDate: new Date(),
        startAt: new Date()
    };
    dateFlags: any[] = [];
    creationFlags: any[] = [];

    // Component variables
    resetField: boolean = false;

    isLoading: boolean = false;
    isSaving: boolean = false;
    isSubmitting: boolean = false;

    promises: Array<any> = [];

    msg: MsgModel;

    // Pipes
    cleanDatePipe: CleanDatePipe = new CleanDatePipe();
    getPropertyPipe: GetPropertyPipe = new GetPropertyPipe();

    // Subscriptions
    subs: Subscription[] = [];

    // Location promises
    regionResolved$ = new Subject<Region>();
    countyResolved$ = new Subject<County>();
    schoolDistrictResolved$ = new Subject<SchoolDistrict>();
    schoolResolved$ = new Subject<School>();

    enrollmentTypes: any[] = [
        { value: 'R', display: 'R - Regular Term Enrollment', disabled: false },
        { value: 'N', display: 'N - Non-attending', disabled: false }
    ];

    constructor(
        public dialogRef: MatDialogRef<EditChildModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private studentSchoolEnrollmentService: StudentSchoolEnrollmentService,
        private studentEligibilitiesService: StudentEligibilitiesService,
        private partyRelationshipsService: PartyRelationshipsService
    ) {
        this.form = fb.group({
            enrollmentType: ['', [Validators.required]],
            track: [''],
            enrollmentDate: ['', [Validators.required]],
            withdrawalDate: [''],
            departureDate: [''],
            enrollmentComment: [''],
            homeSchoolIndicator: [false],
            districtOfResidenceIndicator: [false],
            outOfStateTranscriptIndicator: [false]
        });

        this.selectedIntendToGraduateFrom = new Organization();

        this.subscriptions();
    }

    subscriptions() {
        let enrollmentDateSub = this.form.get('enrollmentDate')!.valueChanges.subscribe((changes) => {
            if (changes && this.mode != 'view') {
                this.setWithdrawalDate(changes);
                this.form.get('withdrawalDate')?.enable();
            } else if (this.form.get('enrollmentType')?.value === 'R') {
                this.form.get('withdrawalDate')?.disable();
            } else {
                this.form.get('withdrawalDate')?.disable();
            }

            //this.enrollmentTypeChange({ value: this.form.get('enrollmentType')?.value });
        });

        let withdrawalDateSub = this.form.get('withdrawalDate')!.valueChanges.subscribe((changes) => {
            if (changes && this.mode != 'view') {
                this.setDepartureDate(changes);
                this.form.get('departureDate')?.enable();
            } else if (this.form.get('enrollmentType')?.value === 'R') {
                this.form.get('departureDate')?.disable();
            } else if (this.form.get('enrollmentType')?.value === 'N' && this.mode != 'view') {
                this.form.get('departureDate')?.enable();
            }

            //this.enrollmentTypeChange({ value: this.form.get('enrollmentType')?.value });
        });

        this.subs.push(enrollmentDateSub);
        this.subs.push(withdrawalDateSub);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    ngOnInit(): void {
        this.isLoading = true;

        // Use data IDs if exists
        if (this.data) {
            this.students = this.data.students;
            this.schoolEnrollment = this.data.schoolEnrollment;
            this.mode = this.data.mode;
        }

        // Reference API calls
        this.getSchoolEnrollmentDetailTypes();
        this.indexPartyRelationshipStatusTypes();

        // Needed
        this.getLatestCoeAndEligiblity(this.students);

        // School Enrollment API calls (if exists)
        if (this.mode === 'view') {
            this.title = 'Viewing School Enrollment';
            this.form.disable();
            this.getSchoolEnrollmentDetails(this.schoolEnrollment.ID);
            this.getSchoolEnrollmentComments(this.schoolEnrollment.ID);
        } else if (this.schoolEnrollment) {
            this.title = 'Editing School Enrollment';
            this.getSchoolEnrollmentDetails(this.schoolEnrollment.ID);
            this.getSchoolEnrollmentComments(this.schoolEnrollment.ID);
        } else {
            this.title = 'Add a new School Enrollment';
            if (this.students.length > 1) {
                this.title += ' for ' + this.students.length + ' children';
            }
        }

        Promise.all(this.promises).then((res) => {
            if (this.schoolEnrollment) {
                this.initEditSchoolEnrollment();
            } else {
                this.initNewSchoolEnrollment();
            }

            this.isLoading = false;
        });
    }

    /*
     * API functions
     */
    getSchoolEnrollmentDetailTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.studentSchoolEnrollmentService.getSchoolEnrollmentDetailTypes().subscribe((res) => {
                if (res.schoolEnrollmentDetailTypes) {
                    this.schoolEnrollmentDetailTypes = res.schoolEnrollmentDetailTypes;
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    indexPartyRelationshipStatusTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.partyRelationshipsService.indexPartyRelationshipStatusTypes().subscribe((res) => {
                if (res.partyRelationshipStatusTypes) {
                    this.partyRelationshipStatusTypes = res.partyRelationshipStatusTypes;
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getLatestCoeAndEligiblity(students: Student[]) {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.getLatestCoeAndEligiblity(students).subscribe((res) => {
                if (res.students) {
                    this.missingEoEStudents = res.students;

                    this.setEligibilityAndTerminationRestrictions(this.missingEoEStudents);

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getSchoolEnrollmentDetails(schoolEnrollmentId: number) {
        let deferred = new Promise((resolve, reject) => {
            this.studentSchoolEnrollmentService.getSchoolEnrollmentDetails(schoolEnrollmentId).subscribe((res) => {
                if (res.schoolEnrollmentDetails) {
                    this.schoolEnrollmentDetails = res.schoolEnrollmentDetails;
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getSchoolEnrollmentComments(schoolEnrollmentId: number) {
        let deferred = new Promise((resolve, reject) => {
            this.studentSchoolEnrollmentService.getSchoolEnrollmentComments(schoolEnrollmentId).subscribe((res) => {
                if (res.schoolEnrollmentComments) {
                    this.schoolEnrollmentComments = res.schoolEnrollmentComments;
                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    /*
     * Common init functions
     */

    /*
     * NEW functions
     */
    initNewSchoolEnrollment() {
        this.form.get('outOfStateTranscriptIndicator')?.disable();
    }

    /*
     * EDIT functions
     */
    async initEditSchoolEnrollment() {
        /*
        // Set location
        setTimeout(() => {
            this.chosenRegion = this.schoolEnrollment.REGION;
            setTimeout(() => {
                this.chosenCounty = this.schoolEnrollment.COUNTy;
                setTimeout(() => {
                    this.chosenSchoolDistrict = this.schoolEnrollment.SCHOOL_DISTRICT;
                    setTimeout(() => {
                        this.chosenSchool = this.schoolEnrollment.SCHOOL;
                    }, 400);
                }, 300);
            }, 200);
        }, 100);
		*/

        // Set form values
        this.setForm(this.schoolEnrollment, this.schoolEnrollmentDetails);

        // Set date values

        // Disable fields for editing mode
        this.form.get('track')?.disable();

        this.chosenRegion = this.schoolEnrollment.REGION;

        await firstValueFrom(this.regionResolved$);
        await firstValueFrom(this.countyResolved$);
        await firstValueFrom(this.schoolDistrictResolved$);
        await firstValueFrom(this.schoolResolved$);
    }

    regionChanged(event: any) {
        if (this.schoolEnrollment) {
            this.chosenCounty = this.schoolEnrollment.COUNTy;
        }

        this.regionResolved$.next(event);
    }

    countyChanged(event: any) {
        if (this.schoolEnrollment) {
            this.chosenSchoolDistrict = this.schoolEnrollment.SCHOOL_DISTRICT;
        }

        this.countyResolved$.next(event);
    }

    schoolDistrictChanged(event: any) {
        if (this.schoolEnrollment) {
            this.chosenSchool = this.schoolEnrollment.SCHOOL;
        }

        this.schoolDistrictResolved$.next(event);
    }

    schoolChanged(event: any) {
        this.schoolResolved$.next(event);
    }

    setForm(schoolEnrollment: SchoolEnrollment, schoolEnrollmentDetails: SchoolEnrollmentDetails[]) {
        let sed: any = {};

        schoolEnrollmentDetails.forEach((schoolEnrollmentDetail: SchoolEnrollmentDetails) => {
            sed[schoolEnrollmentDetail.SCHOOL_ENROLLMENT_DETAIL_TYPES.TYPE] = schoolEnrollmentDetail.VALUE;
        });

        this.sed = sed;

        this.form.patchValue({
            enrollmentType: sed['EnrollmentType'],
            track: sed['Track'],
            enrollmentDate: this.cleanDatePipe.transform(sed['EnrollmentDate']),
            withdrawalDate: this.cleanDatePipe.transform(sed['WithdrawalDate']),
            departureDate: this.cleanDatePipe.transform(sed['DepartureDate']),
            enrollmentComment: this.schoolEnrollmentComments ? this.schoolEnrollmentComments.COMMENT : '',
            homeSchoolIndicator: sed['HomeSchoolIndicator'] ? true : false,
            districtOfResidenceIndicator: sed['DistrictOfResidenceIndicator'] ? true : false,
            outOfStateTranscriptIndicator: sed['OutOfStateTranscriptIndicator'] ? true : false
        });

        this.selectSchoolYear = sed['SchoolYear'];
        this.selectedSchoolYear = sed['SchoolYear'];
        if (sed['Grade']) {
            let newGrade = new Grade();
            newGrade.GRADES = sed['Grade'];
            this.chosenGrades.push(newGrade);
        }
        if (sed['IntendToGradFrom']) {
            let newOrganization = new Organization();
            newOrganization.ID = sed['IntendToGradFrom'];
            this.selectedIntendToGraduateFrom = newOrganization;
        }
        if (sed['ResidenceDistrict']) {
            let newOrganization = new Organization();
            newOrganization.ID = sed['ResidenceDistrict'];
            this.residenceDistrict = newOrganization;
        }

        // Set events
        sed['HomeSchoolIndicator'] ? this.homeSchoolIndicatorEvent({ checked: true }) : undefined;
        this.enrollmentTypeChange({ value: sed['EnrollmentType'] });
    }

    /*
     * SUBMIT functions
     */
    submit() {
        if (this.checkValid()) {
            this.isSubmitting = true;
            this.msg = new MsgModel();

            let payload = this.generatePayload();
            //console.warn(payload);

            if (this.schoolEnrollment) {
                this.studentSchoolEnrollmentService.update(payload.schoolEnrollment).subscribe({
                    next: (res) => {
                        if (res.msg) {
                            if (res.msg.SUCCESS) {
                                this.msg = res.msg;

                                this.msg.MSG += ' (closing modal in 3 seconds...)';
                                setTimeout(() => {
                                    this.dialogRef.close({ refresh: true });
                                }, 3000);
                            } else {
                                this.msg = res.msg;
                            }
                        } else {
                            this.msg = { MSG: 'There was an error updating this school enrollment', SUCCESS: false };
                        }
                    },
                    error: (err) => {
                        if (err.msg) {
                            this.msg = err.msg;
                        } else {
                            this.msg = { MSG: 'Server error.', SUCCESS: false };
                        }
                    },
                    complete: () => {
                        this.isSubmitting = false;
                    }
                });
            } else {
                this.studentSchoolEnrollmentService.createV2(payload.students, payload.schoolEnrollment).subscribe({
                    next: (res) => {
                        if (res.msg) {
                            if (res.msg.SUCCESS) {
                                this.msg = res.msg;

                                this.msg.MSG += ' (closing modal in 3 seconds...)';
                                setTimeout(() => {
                                    this.dialogRef.close({ refresh: true });
                                }, 3000);
                            } else {
                                this.msg = res.msg;
                            }
                        } else {
                            this.msg = { MSG: 'There was an error creating this school enrollment', SUCCESS: false };
                        }
                    },
                    error: (err) => {
                        if (err.msg) {
                            this.msg = err.msg;
                        } else {
                            this.msg = { MSG: 'Server error.', SUCCESS: false };
                        }
                    },
                    complete: () => {
                        this.isSubmitting = false;
                    }
                });
            }
        }
    }

    checkValid() {
        this.form.markAllAsTouched();
        let valid = true;
        if (this.creationFlags.length > 0) {
            this.msg = { MSG: 'A child is ineligible for the selected school year.', SUCCESS: false };
            valid = false;
        } else if (!this.chosenRegion?.ID) {
            this.msg = { MSG: 'Please select a Region', SUCCESS: false };
            valid = false;
        } else if (!this.chosenCounty?.ID) {
            this.msg = { MSG: 'Please select a County', SUCCESS: false };
            valid = false;
        } else if (!this.chosenSchoolDistrict?.ID) {
            this.msg = { MSG: 'Please select a School District', SUCCESS: false };
            valid = false;
        } else if (!this.chosenSchool?.ID) {
            this.msg = { MSG: 'Please select a School', SUCCESS: false };
            valid = false;
        } else if (!this.chosenGrades || this.chosenGrades.length === 0) {
            this.msg = { MSG: 'Please select a Grade', SUCCESS: false };
            valid = false;
        } else if (!this.selectedSchoolYear) {
            this.msg = { MSG: 'Please select a School Year', SUCCESS: false };
            valid = false;
            // } else if (this.intendToGraduateFromRequired && (!this.selectedIntendToGraduateFrom || !this.selectedIntendToGraduateFrom.ID)) {
            //     this.msg = { MSG: 'Please designate a school to graduate from', SUCCESS: false };
            //     valid = false;
        } else if (this.form.invalid) {
            this.msg = { MSG: 'Please input required fields', SUCCESS: false };
            valid = false;
        }

        setTimeout(() => {
            this.msg = undefined!;
        }, 7000);

        return valid;
    }

    // Payload generation
    generatePayload() {
        let payload: any = {};
        payload.students = JSON.parse(
            JSON.stringify(
                this.students.map((student) => {
                    return { ID: student.ID };
                })
            )
        );
        let schoolEnrollment: SchoolEnrollment = new SchoolEnrollment();

        if (this.schoolEnrollment) {
            schoolEnrollment.ID = this.schoolEnrollment.ID;

            schoolEnrollment.PARTY_RELATIONSHIPS = this.schoolEnrollment.PARTY_RELATIONSHIPS;
        }

        // Location
        schoolEnrollment.REGION = this.chosenRegion!;
        schoolEnrollment.COUNTy = this.chosenCounty!;
        schoolEnrollment.SCHOOL_DISTRICT = this.chosenSchoolDistrict!;
        schoolEnrollment.SCHOOL = this.chosenSchool!;

        // SchoolEnrollmentDetails
        schoolEnrollment.SCHOOL_ENROLLMENT_DETAILS = this.generateSchoolEnrollmentDetails();

        // Comments
        let schoolEnrollmentComment = new SchoolEnrollmentComments();
        schoolEnrollmentComment.COMMENT = this.form.get('enrollmentComment')?.value ? this.form.get('enrollmentComment')?.value : '';
        schoolEnrollment.SCHOOL_ENROLLMENT_COMMENTS = schoolEnrollmentComment;

        payload.schoolEnrollment = schoolEnrollment;

        return payload;
    }

    generateSchoolEnrollmentDetails(): SchoolEnrollmentDetails[] {
        let schoolEnrollmentDetails: SchoolEnrollmentDetails[] = [];

        // From form
        /*
            enrollmentType: ['', [Validators.required]],
            track: [''],
            enrollmentDate: ['', [Validators.required]],
            withdrawalDate: [''],
            departureDate: [''],
            enrollmentComment: [''],
			outOfStateTranscriptIndicator: [false],
			homeSchoolIndicator: [false],
			districtOfResidenceIndicator: [false],
		*/
        this.schoolEnrollmentDetailTypes.forEach((sedt) => {
            let sed: any = {};
            switch (sedt.TYPE) {
                case 'SchoolYear':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.selectedSchoolYear;
                    break;
                case 'EnrollmentType':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.form.get('enrollmentType')?.value;
                    break;
                case 'EnrollmentDate':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.form.get('enrollmentDate')?.value;
                    break;
                case 'WithdrawalDate':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.form.get('withdrawalDate')?.value;
                    break;
                case 'DepartureDate':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.form.get('departureDate')?.value;
                    break;
                case 'Grade':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.chosenGrades.length > 0 ? this.chosenGrades[0].GRADES : undefined;
                    break;
                case 'IntendToGradFrom':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.selectedIntendToGraduateFrom ? this.selectedIntendToGraduateFrom.ID : undefined;
                    break;
                case 'Track':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.form.get('track')?.value;
                    break;
                case 'OutOfStateTranscriptIndicator':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.form.get('outOfStateTranscriptIndicator')?.value ? true : '';
                    break;
                case 'HomeSchoolIndicator':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.form.get('homeSchoolIndicator')?.value ? true : '';
                    break;
                case 'DistrictOfResidenceIndicator':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.form.get('districtOfResidenceIndicator')?.value ? true : '';
                    break;
                case 'ResidenceDistrict':
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sedt.ID;
                    sed.VALUE = this.residenceDistrict ? this.residenceDistrict.ID : undefined;
                    break;
            }

            if (sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID) {
                schoolEnrollmentDetails.push(sed);
            }
        });

        // Backfill legacy data
        if (this.schoolEnrollmentDetails) {
            this.schoolEnrollmentDetails.forEach((sed1) => {
                let foundIndex = schoolEnrollmentDetails.findIndex((sed2) => sed1.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID === sed2.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID);

                if (foundIndex === -1) {
                    let sed: any = {};
                    sed.ID = sed1.ID;
                    sed.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID = sed1.SCHOOL_ENROLLMENT_DETAIL_TYPES_ID;
                    sed.VALUE = sed1.VALUE;
                    schoolEnrollmentDetails.push(sed);
                }
            });
        }

        return schoolEnrollmentDetails;
    }

    // Dialog function
    closeDialog(closed: boolean) {
        if (this.mode === 'view') {
            this.dialogRef.close();
        } else {
            Swal.fire({
                titleText: 'Are you sure you want to continue without saving?',
                showDenyButton: false,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Go Back',
                icon: 'warning',
                confirmButtonColor: '#3a6b35'
            }).then((result: any) => {
                if (result.isConfirmed) {
                    this.dialogRef.close();
                }
            });
        }
    }

    schoolYearEvent(schoolYear: string) {
        this.selectedSchoolYear = schoolYear;

        this.setDates();
    }

    gradeEventEmitter(grades: Grade[]) {
        if (grades) {
            let currentGrade: any;
            if (Array.isArray(grades)) {
                currentGrade = grades[0];
            } else {
                currentGrade = grades;
            }

            if (currentGrade) {
                switch (currentGrade.GRADES) {
                    case '09':
                    case '10':
                    case '11':
                    case '12':
                        if (this.mode != 'view') {
                            this.form.get('outOfStateTranscriptIndicator')?.enable();
                        }
                        break;

                    default:
                        this.form.patchValue({
                            outOfStateTranscriptIndicator: false
                        });
                        this.form.get('outOfStateTranscriptIndicator')?.disable();
                        break;
                }
            }

            this.requiredIntendToGraduateFrom();
        }
    }

    enrollmentTypeChange(event: any) {
        if (event.value === 'R') {
            if (this.mode == 'view') {
                this.form.get('enrollmentDate')?.disable();
                this.form.get('withdrawalDate')?.disable();
                this.form.get('departureDate')?.disable();
            } else {
                if (this.selectedSchoolYear) {
                    this.form.get('enrollmentDate')?.enable();
                } else {
                    this.form.get('enrollmentDate')?.disable();
                }

                if (this.form.get('enrollmentDate')?.value) {
                    this.form.get('withdrawalDate')?.enable();
                } else {
                    this.form.get('withdrawalDate')?.disable();
                    this.form.patchValue({
                        withdrawalDate: ''
                    });
                }
                if (this.form.get('withdrawalDate')?.value) {
                    this.form.get('departureDate')?.enable();
                } else {
                    this.form.get('departureDate')?.disable();
                    this.form.patchValue({
                        departureDate: ''
                    });
                }
            }

            this.form.get('enrollmentDate')?.setValidators([Validators.required]);
            this.form.get('enrollmentDate')?.updateValueAndValidity();

            if (this.sed['WithdrawalDate']) {
                this.form.get('withdrawalDate')?.setValidators([Validators.required]);
                this.form.get('withdrawalDate')?.updateValueAndValidity();
            }

            if (this.sed['DepartureDate']) {
                this.form.get('departureDate')?.setValidators([Validators.required]);
                this.form.get('departureDate')?.updateValueAndValidity();
            }
        } else if (event.value === 'N') {
            this.form.get('enrollmentDate')?.disable();
            this.form.get('withdrawalDate')?.disable();
            if (this.mode != 'view') {
                this.form.get('departureDate')?.enable();
            }

            this.form.patchValue({
                enrollmentDate: '',
                withdrawalDate: ''
            });

            this.form.get('enrollmentDate')?.setValidators([]);
            this.form.get('enrollmentDate')?.updateValueAndValidity();

            if (this.sed['DepartureDate']) {
                this.form.get('departureDate')?.setValidators([Validators.required]);
                this.form.get('departureDate')?.updateValueAndValidity();
            }
        }

        this.requiredIntendToGraduateFrom();
    }

    homeSchoolIndicatorEvent(event: any) {
        if (event.checked) {
            this.form.patchValue({
                enrollmentType: 'N',
                enrollmentDate: '',
                withdrawalDate: '',
                districtOfResidenceIndicator: false
            });

            this.residenceDistrict = new Organization();

            let rEnrollmentTypeIndex = this.enrollmentTypes.findIndex((et) => et.value === 'R');
            if (rEnrollmentTypeIndex >= 0) {
                this.enrollmentTypes[rEnrollmentTypeIndex].disabled = true;
            }

            this.form.get('districtOfResidenceIndicator')?.disable();
            this.form.get('enrollmentDate')?.disable();
            this.form.get('withdrawalDate')?.disable();

            this.enrollmentTypeChange({ value: 'N' });
        } else {
            let rEnrollmentTypeIndex = this.enrollmentTypes.findIndex((et) => et.value === 'R');
            if (rEnrollmentTypeIndex >= 0) {
                this.enrollmentTypes[rEnrollmentTypeIndex].disabled = false;
            }

            if (this.mode != 'view') {
                this.form.get('districtOfResidenceIndicator')?.enable();
                this.form.get('enrollmentDate')?.enable();
                this.form.get('withdrawalDate')?.enable();
            }
        }
    }

    // Require changes based on form changes
    requiredIntendToGraduateFrom() {
        if (this.chosenGrades && this.chosenGrades.length > 0) {
            let required = !!['09', '10', '11', '12'].find((grade) => grade === this.chosenGrades[0].GRADES) && this.form.get('enrollmentType')?.value === 'R';
            this.intendToGraduateFromRequired = required;
            this.intendToGraduateFromDisabled = !required;
            if (this.intendToGraduateFromDisabled) {
                this.selectedIntendToGraduateFrom = new Organization();
            }

            return required;
        } else {
            this.intendToGraduateFromRequired = false;
            this.intendToGraduateFromDisabled = true;
            return false;
        }
    }

    // Date Filters
    setEligibilityAndTerminationRestrictions(students: Student[]) {
        students.forEach((student) => {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );

            if (eoeDate) {
                if (!this.maxEndOfEligibilityStudent) {
                    this.maxEndOfEligibilityStudent = student;
                } else {
                    let currentEoE = this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(
                            this.maxEndOfEligibilityStudent,
                            'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                        )
                    );

                    if (new Date(eoeDate) < new Date(currentEoE)) {
                        this.maxEndOfEligibilityStudent = student;
                    }
                }
            }

            let terminationID = this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].ID');
            let terminationDate = this.cleanDatePipe.transform(this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE'));
            let terminationTypeID = this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.ID');

            if (terminationID) {
                if (!this.maxTerminationStudent && terminationTypeID !== 1) {
                    this.maxTerminationStudent = student;
                } else {
                    let currentTerminationDate = this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
                    );

                    if (new Date(terminationDate) < new Date(currentTerminationDate) && terminationTypeID !== 1) {
                        this.maxTerminationStudent = student;
                    }
                }
            }
        });
    }

    setDates() {
        this.dateFlags = [];
        this.creationFlags = [];

        this.setEnrollmentDates();
        this.setWithdrawalDate();
        this.setDepartureDate();
        // console.warn(this.maxEndOfEligibilityStudent);
        // console.warn(this.dateFlags);
    }

    setEnrollmentDates() {
        let currentYear: number = parseInt(this.selectedSchoolYear.substring(0, 4));
        let nextYear: number = currentYear + 1;
        let minDate: Date = new Date(currentYear, 6, 1);
        let maxDate: Date = new Date(nextYear, 5, 30);

        this.enrollmentDateOptions.minDate = minDate;
        this.enrollmentDateOptions.maxDate = maxDate;
        this.enrollmentDateOptions.startAt = minDate;

        if (this.maxEndOfEligibilityStudent && this.maxTerminationStudent) {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );
            let terminationDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
            );

            if (eoeDate <= terminationDate) {
                if (eoeDate < this.enrollmentDateOptions.maxDate) {
                    let studentName = this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                        ? this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                        : this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.FIRST_NAME') +
                          ' ' +
                          this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.LAST_NAME');
                    let msdNumber = this.maxEndOfEligibilityStudent.MSD_NUMBER;
                    this.enrollmentDateOptions.maxDate = eoeDate;

                    this.dateFlags.push({
                        MIN_MAX: 'Maximum',
                        DATE_TYPE: 'Enrollment',
                        TYPE: 'End of Eligibility',
                        DATE: eoeDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });

                    if (eoeDate < this.enrollmentDateOptions.minDate) {
                        this.creationFlags.push({
                            TYPE: 'End of Eligibility',
                            DATE: eoeDate,
                            NAME: studentName,
                            MSD_NUMBER: msdNumber
                        });
                    }
                }
            } else {
                if (terminationDate < this.enrollmentDateOptions.maxDate) {
                    let studentName = this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                        ? this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                        : this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.FIRST_NAME') +
                          ' ' +
                          this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.LAST_NAME');
                    let msdNumber = this.maxTerminationStudent.MSD_NUMBER;
                    this.enrollmentDateOptions.maxDate = terminationDate;

                    this.dateFlags.push({
                        MIN_MAX: 'Maximum',
                        DATE_TYPE: 'Enrollment',
                        TYPE: 'Termination',
                        DATE: terminationDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });

                    if (terminationDate < this.enrollmentDateOptions.minDate) {
                        this.creationFlags.push({
                            TYPE: 'Termination',
                            DATE: terminationDate,
                            NAME: studentName,
                            MSD_NUMBER: msdNumber
                        });
                    }
                }
            }
        } else if (this.maxEndOfEligibilityStudent) {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );
            if (eoeDate < this.enrollmentDateOptions.maxDate) {
                let studentName = this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                    ? this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                    : this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.FIRST_NAME') +
                      ' ' +
                      this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.LAST_NAME');
                let msdNumber = this.maxEndOfEligibilityStudent.MSD_NUMBER;
                this.enrollmentDateOptions.maxDate = eoeDate;

                this.dateFlags.push({
                    MIN_MAX: 'Maximum',
                    DATE_TYPE: 'Enrollment',
                    TYPE: 'End of Eligibility',
                    DATE: eoeDate,
                    NAME: studentName,
                    MSD_NUMBER: msdNumber
                });

                if (eoeDate < this.enrollmentDateOptions.minDate) {
                    this.creationFlags.push({
                        TYPE: 'End of Eligibility',
                        DATE: eoeDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });
                }
            }
        } else if (this.maxTerminationStudent) {
            let terminationDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
            );
            if (terminationDate < this.enrollmentDateOptions.maxDate) {
                let studentName = this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                    ? this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                    : this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.FIRST_NAME') +
                      ' ' +
                      this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.LAST_NAME');
                let msdNumber = this.maxTerminationStudent.MSD_NUMBER;
                this.enrollmentDateOptions.maxDate = terminationDate;

                this.dateFlags.push({
                    MIN_MAX: 'Maximum',
                    DATE_TYPE: 'Enrollment',
                    TYPE: 'Termination',
                    DATE: terminationDate,
                    NAME: studentName,
                    MSD_NUMBER: msdNumber
                });

                if (terminationDate < this.enrollmentDateOptions.minDate) {
                    this.creationFlags.push({
                        TYPE: 'Termination',
                        DATE: terminationDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });
                }
            }
        }
    }

    setWithdrawalDate(enrollmentDate?: Date) {
        let currentYear: number = parseInt(this.selectedSchoolYear.substring(0, 4));
        let nextYear: number = currentYear + 1;
        let minDate: Date = new Date(currentYear, 6, 1);
        let maxDate: Date = new Date(nextYear, 7, 31);

        if (enrollmentDate) {
            this.withdrawalDateOptions.minDate = enrollmentDate;
            this.withdrawalDateOptions.maxDate = maxDate;
            this.withdrawalDateOptions.startAt = minDate;
        } else {
            this.withdrawalDateOptions.minDate = minDate;
            this.withdrawalDateOptions.maxDate = maxDate;
            this.withdrawalDateOptions.startAt = minDate;
        }
    }

    setDepartureDate(withdrawalDate?: Date) {
        let currentYear: number = parseInt(this.selectedSchoolYear.substring(0, 4));
        let minDate: Date = new Date(currentYear, 6, 1);

        if (withdrawalDate) {
            this.departureDateOptions.minDate = withdrawalDate;
            this.departureDateOptions.maxDate = undefined!;
            this.departureDateOptions.startAt = minDate;
        } else {
            this.departureDateOptions.minDate = minDate;
            this.departureDateOptions.maxDate = undefined!;
            this.departureDateOptions.startAt = minDate;
        }
    }

    enrollmentDateFilter = (date: Date | null): boolean => {
        let currentYear: number = parseInt(this.selectedSchoolYear.substring(0, 4));
        let nextYear: number = currentYear + 1;
        let minDate: Date = new Date(currentYear.toString + '-07-01');
        let maxDate: Date = new Date(nextYear.toString + '-06-30');

        // console.log(date ? date.getTime() : null);
        // console.log(minDate.getTime());
        // console.log(maxDate.getTime());

        return date ? date.getTime() !== minDate.getTime() : false;
    };
}
